/** Prefer real name (first + last); fall back to username when names are empty. */
export function formatTicketSender(ticket) {
  if (!ticket) return '';
  const first = ticket.user_first_name ?? ticket.sender_first_name ?? '';
  const last = ticket.user_last_name ?? ticket.sender_last_name ?? '';
  const full = [first, last].filter(Boolean).join(' ').trim();
  if (full) return full;
  return (ticket.sender_username ?? ticket.user_username ?? ticket.username ?? '').trim();
}

/** Full name plus username in parens when both exist and differ. */
export function formatTicketSenderWithUsername(ticket) {
  const full = [ticket?.user_first_name ?? ticket?.sender_first_name, ticket?.user_last_name ?? ticket?.sender_last_name]
    .filter(Boolean).join(' ').trim();
  const username = (ticket?.sender_username ?? ticket?.user_username ?? ticket?.username ?? '').trim();
  if (full && username && full !== username) return `${full} (${username})`;
  return full || username;
}
